package net.maraclinic.app

import org.jetbrains.compose.web.css.*

fun CSSBuilder.displayFlexColumn() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    width(100.percent)
}

fun CSSBuilder.displayFlexRow() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Row)
    width(100.percent)
}